import { combineReducers } from 'redux';
import { tourAvailabilityReducer } from './tour-availability';
import { tourDossiersReducer } from './tour-dossiers';
import { tourFiltersReducer } from './tour-filters';
import { tourReferencesReducer } from './tour-references';
import { tourRoomsReducer } from './tour-rooms';
import { tourSummaryReducer } from './tour-summary';

export const combinedToursReducers = combineReducers({
  tourAvailability: tourAvailabilityReducer,
  tourDossiers: tourDossiersReducer,
  tourFilters: tourFiltersReducer,
  tourReferences: tourReferencesReducer,
  tourRooms: tourRoomsReducer,
  tourSummary: tourSummaryReducer
});

export type CombinedToursReducersType = ReturnType<typeof combinedToursReducers>;
